import React from "react";
import "./styles.scss";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick"; 
import NoImage from "../../assets/images/NoImage.png"; 
import QuiteIcon from "../../assets/images/icons/quote.png";
import QuiteIcon1 from "../../assets/images/icons/quote1.png";
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import { testimonials } from "../../data/courses-data/testimonials";

import Para from "../Para";
import SectionHeader from "../SectionHeader";

export default function Testimonial() {
  var settingsImage = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    fade: true,
    autoplay: true,
    // speed: 1000,
    autoplaySpeed: 10000,
    // cssEase: "linear",
    prevArrow: (
      <button type="button" className="slick-prev">
        <FaChevronLeft />
      </button>
    ),
    nextArrow: (
      <button type="button" className="slick-next">
        <FaChevronRight />
      </button>
    ),
    adaptiveHeight: true,
  };

  return (
    <div className="testmonialwrapper">
      <Container>
        <Row>
          <Col sm={12} md={12} lg={12}>
            <div className="testnonil-imagewrap">
              <Slider {...settingsImage} className="testimonial__image-active ">
                {testimonials.map((testimonial, index) => (
                  <div key={index}>
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col md={10} className=" offset-md-1">
                            <div className="testmonial-content">
                              <SectionHeader>
                                <h2 className="title text-white text-center">
                                  {/* <i> What Our Students Say About Us</i> */}
                                  <i> What Students Say</i>
                                </h2>
                              </SectionHeader>

                              <div className="testmon-img-items">
                                {testimonial.image ? (
                                  <img src={testimonial.image} alt="img" />
                                ) : (
                                  <img src={NoImage} alt="img" />
                                )}
                                <div className="testmonial-avatar">
                                  <h3 className="name">{testimonial.name}</h3>
                                </div>
                              </div>

                              <Para className="para textmonial-para mt-3">
                                <img
                                  src={QuiteIcon}
                                  alt="imageicon"
                                  width={20}
                                  className="d-inline-block me-2"
                                />
                                {testimonial.content}
                                <img
                                  src={QuiteIcon1}
                                  alt="imageicon"
                                  width={20}
                                  className="d-inline-block ms-2"
                                />
                              </Para>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
